import { ProfessionId } from "@/constants/professions"
import { atom } from "jotai"

export const defaultProfession: ProfessionId = "delivery"
export const professionDraftAtom = atom<ProfessionId>(defaultProfession)
